import AboutMeApp from "@/_roots/aboutMe/AboutMeApp.vue";
import VueInstance from "@/main";
import router from "@/_roots/aboutMe/router";

VueInstance(AboutMeApp, router);
